import { HStack } from '@genial/components';

import { useGlobalAssetContext } from '../../contexts';
import { AssetCategories } from '../AssetCategories';
import { AssetFilters, AssetFiltersDisabled } from '../AssetFilters';
import { AssetOrderBy } from '../AssetOrderBy';
import { AssetsRefreshList } from '../AssetsRefreshList';
import { MarketStatus } from '../MarketStatus';

export const AssetHandlers = () => {
  const { selectedTab, isDesktop } = useGlobalAssetContext();

  const isEquity = selectedTab.id === 'equity';

  if (!selectedTab.hasCategories || !isDesktop) {
    return (
      <HStack w="full" justifyContent="space-between" alignItems="center" pt="stack.xxs">
        <HStack alignItems="center">
          <MarketStatus />
          <AssetsRefreshList />
        </HStack>
        <HStack space="inline.nano" alignItems="center">
          <AssetOrderBy />
          {isEquity ? <AssetFiltersDisabled /> : <AssetFilters />}
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack w="full" justifyContent="space-between" alignItems="center" pt="stack.xxs">
      <AssetCategories />
      <HStack space="inline.nano" alignItems="center">
        <MarketStatus />
        <AssetsRefreshList />
        <AssetOrderBy />
        <AssetFilters />
      </HStack>
    </HStack>
  );
};
